// Mirrors the Python constants in apps/api/services/impersonation_detection_service.py
// — kept as constants here (not derived from an API response) so the
// threshold tick-marks on the "why it was flagged" bars render without a
// round trip. If those Python constants ever change, update here too.
export const IMPERSONATION_THRESHOLDS = {
  nearHandle: 0.90,       // NEAR_HANDLE_THRESHOLD (Jaro-Winkler)
  highNameSimilarity: 0.75, // HIGH_SIMILARITY_THRESHOLD
  mediumNameSimilarity: 0.50, // MEDIUM_SIMILARITY_THRESHOLD
  scamRisk: 0.85,         // SCAM_RISK_THRESHOLD
  bioFanSemantic: 0.60,   // BIO_SEMANTIC_FAN_THRESHOLD
} as const;
